import React from "react";
import { useLanguage } from "../utils/LanguageContext";
import en from "../utils/languages/en.jsx";
import fr from "../utils/languages/fr.jsx";
const Technologies = ({ theme }) => {
  const { language } = useLanguage();
  const translations = {
    en,
    fr,
  };

  const currentTranslations = translations[language];
  return (
    <section className="py-5" id="tech">
      <div className="w-16 h-2 rounded-full bg-gradient-to-r from-violet-500 to-sky-500 mt-5"></div>
      <h2 className={`${theme === "dark" ? "title-dark" : "title"}`}>
        {currentTranslations.technoTitle}
      </h2>
      <p className="text-lg md:text-xl pb-14 text-gray-400 max-w-4xl xxxs:ml-2 xxs:ml-2  xs:ml-2 dark:text-gray-600">
        {currentTranslations.technoInfo}
      </p>

      <div className="grid grid-cols-[repeat(auto-fill,minmax(16rem,1fr))] gap-x-8 gap-y-10">
        {currentTranslations.technologies.map(
          ({ icon, point, title, list, id }) => (
            <div
              key={id}
              className="h-full shadow-xl rounded-lg bg-slate-800 p-4 flex flex-row items-center dark:bg-gray-800"
            >
              <div className="flex flex-col  justify-start gap-4">
                <div className="flex flex-row items-center justify-start gap-4">
                  <span> {icon}</span>
                  <h2 className="text-white font-bold text-lg">{title}</h2>
                </div>
                <ul className="flex flex-col justify-start px-2 gap-y-2">
                  {list.map((tech, index) => (
                    <li key={index} className="flex flex-row gap-x-4">
                      <span className="dark:text-white">{point}</span>
                      <span className="text-gray-400 text-lg dark:text-slate-300">
                        {tech}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default Technologies;
